import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapLayerToolForm, MapDomain, LayerToolDefaults, MapDynamicDomainDimension, MapDomainArrayManager, CountAggregationFunction, SumAggregationFunction, MapDomainDimension, MapTypeDimension, BooleanTypeManager, StringTypeManager, IntegerRangeManager, IntegerTypeManager, LayerToolState, MapLayerToolLegend, roundValues, AbstractLayerTool, GeoJSONTypes, LayerToolRenderType, DataChangeEvent, DataManagerChangeEvent, GeoDataChangeEvent, GeoDataManagerChangeEvent } from 'geovisto';

// Geovisto core
/**
 * This class provides controls for management of the layer sidebar tab.
 *
 * @author Jiri Hynek
 */
class ChoropolethLayerToolMapForm extends MapLayerToolForm {
    /**
     * It creates new map form with respect to the given props.
     *
     * @param tool
     */
    constructor(tool) {
        super(tool);
    }
    /**
     * It updates selected input values according to the given dimensions.
     *
     * @param dimensions
     */
    setInputValues(dimensions) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15;
        // update inputs
        (_a = this.inputs) === null || _a === void 0 ? void 0 : _a.geoData.setValue((_c = ((_b = dimensions.geoData.getValue()) === null || _b === void 0 ? void 0 : _b.getName())) !== null && _c !== void 0 ? _c : "");
        (_d = this.inputs) === null || _d === void 0 ? void 0 : _d.geoId.setValue((_f = ((_e = dimensions.geoId.getValue()) === null || _e === void 0 ? void 0 : _e.getName())) !== null && _f !== void 0 ? _f : "");
        (_g = this.inputs) === null || _g === void 0 ? void 0 : _g.value.setValue((_j = ((_h = dimensions.value.getValue()) === null || _h === void 0 ? void 0 : _h.getName())) !== null && _j !== void 0 ? _j : "");
        (_k = this.inputs) === null || _k === void 0 ? void 0 : _k.aggregation.setValue((_m = ((_l = dimensions.aggregation.getValue()) === null || _l === void 0 ? void 0 : _l.getName())) !== null && _m !== void 0 ? _m : "");
        (_o = this.inputs) === null || _o === void 0 ? void 0 : _o.customColor.setValue((_p = (dimensions.customColor.getValue())) !== null && _p !== void 0 ? _p : "");
        (_q = this.inputs) === null || _q === void 0 ? void 0 : _q.color.setValue((_r = (dimensions.color.getValue())) !== null && _r !== void 0 ? _r : "");
        (_s = this.inputs) === null || _s === void 0 ? void 0 : _s.range.setValue((_t = (dimensions.range.getValue())) !== null && _t !== void 0 ? _t : "");
        (_u = this.inputs) === null || _u === void 0 ? void 0 : _u.scaling.setValue((_w = ((_v = dimensions.scaling.getValue()) === null || _v === void 0 ? void 0 : _v.getName())) !== null && _w !== void 0 ? _w : "");
        (_x = this.inputs) === null || _x === void 0 ? void 0 : _x.customMinMax.setValue((_y = (dimensions.customMinMax.getValue())) !== null && _y !== void 0 ? _y : "");
        (_z = this.inputs) === null || _z === void 0 ? void 0 : _z.minValue.setValue((_0 = (dimensions.minValue.getValue())) !== null && _0 !== void 0 ? _0 : "");
        (_1 = this.inputs) === null || _1 === void 0 ? void 0 : _1.maxValue.setValue((_2 = (dimensions.maxValue.getValue())) !== null && _2 !== void 0 ? _2 : "");
        (_3 = this.inputs) === null || _3 === void 0 ? void 0 : _3.units.setValue((_4 = (dimensions.units.getValue())) !== null && _4 !== void 0 ? _4 : "");
        (_5 = this.inputs) === null || _5 === void 0 ? void 0 : _5.unitsDesc.setValue((_6 = (dimensions.unitsDesc.getValue())) !== null && _6 !== void 0 ? _6 : "");
        // update disabled attribute
        (_7 = this.inputs) === null || _7 === void 0 ? void 0 : _7.color.setDisabled(!dimensions.customColor.getValue());
        (_8 = this.inputs) === null || _8 === void 0 ? void 0 : _8.scaling.setDisabled((_9 = dimensions.customMinMax.getValue()) !== null && _9 !== void 0 ? _9 : false);
        (_10 = this.inputs) === null || _10 === void 0 ? void 0 : _10.minValue.setDisabled(!dimensions.customMinMax.getValue());
        (_11 = this.inputs) === null || _11 === void 0 ? void 0 : _11.maxValue.setDisabled(!dimensions.customMinMax.getValue());
        (_12 = this.inputs) === null || _12 === void 0 ? void 0 : _12.unitsEnabled.setDisabled((_13 = dimensions.unitsEnabled.getValue()) !== null && _13 !== void 0 ? _13 : false);
        (_14 = this.inputs) === null || _14 === void 0 ? void 0 : _14.units.setDisabled(!dimensions.unitsEnabled.getValue());
        (_15 = this.inputs) === null || _15 === void 0 ? void 0 : _15.unitsDesc.setDisabled(!dimensions.unitsEnabled.getValue());
    }
    /**
     * It returns the sidebar tab pane.
     */
    getContent() {
        if (this.htmlContent == undefined) {
            // tab content
            this.htmlContent = document.createElement('div');
            const elem = this.htmlContent.appendChild(document.createElement('div'));
            // get data mapping model
            const dimensions = this.getMapObject().getState().getDimensions();
            // create inputs
            this.inputs = {
                geoData: this.getInputGeoData(dimensions.geoData),
                geoId: this.getInputGeoId(dimensions.geoId),
                value: this.getInputValue(dimensions.value),
                aggregation: this.getInputAggregation(dimensions.aggregation),
                customColor: this.getInputCustomColor(dimensions.customColor),
                color: this.getInputColor(dimensions.color),
                range: this.getInputRange(dimensions.range),
                scaling: this.getInputScaling(dimensions.scaling),
                customMinMax: this.getInputCustomMinMax(dimensions.customMinMax),
                minValue: this.getInputMinValue(dimensions.minValue),
                maxValue: this.getInputMaxValue(dimensions.maxValue),
                unitsEnabled: this.getInputUnitsEnabled(dimensions.unitsEnabled),
                units: this.getInputUnits(dimensions.units),
                unitsDesc: this.getInputUnitsDesc(dimensions.unitsDesc),
            };
            // append to DOM
            elem.appendChild(this.inputs.geoData.create());
            elem.appendChild(this.inputs.geoId.create());
            elem.appendChild(this.inputs.value.create());
            elem.appendChild(this.inputs.aggregation.create());
            elem.appendChild(this.inputs.customColor.create());
            elem.appendChild(this.inputs.color.create());
            elem.appendChild(this.inputs.range.create());
            elem.appendChild(this.inputs.scaling.create());
            elem.appendChild(this.inputs.customMinMax.create());
            elem.appendChild(this.inputs.minValue.create());
            elem.appendChild(this.inputs.maxValue.create());
            elem.appendChild(this.inputs.unitsEnabled.create());
            elem.appendChild(this.inputs.units.create());
            elem.appendChild(this.inputs.unitsDesc.create());
            // set input values
            this.setInputValues(dimensions);
        }
        return this.htmlContent;
    }
    /**
     * It returns new input for the geo data dimension.
     *
     * @param dimension
     */
    getInputGeoData(dimension) {
        return this.getAutocompleteInput(dimension);
    }
    /**
     * It returns new input for the geo id dimension.
     *
     * @param dimension
     */
    getInputGeoId(dimension) {
        return this.getAutocompleteInput(dimension);
    }
    /**
     * It returns new input for the geo dimension.
     *
     * @param dimension
     */
    getInputValue(dimension) {
        return this.getAutocompleteInput(dimension);
    }
    /**
     * It returns new input for the geo dimension.
     *
     * @param dimension
     */
    getInputAggregation(dimension) {
        return this.getAutocompleteInput(dimension);
    }
    /**
     * It returns new input for the custom color dimension.
     *
     * @param dimension
     */
    getInputCustomColor(dimension) {
        return this.getCheckboxInput(dimension, (ev) => {
            var _a;
            (_a = this.inputs) === null || _a === void 0 ? void 0 : _a.color.setDisabled(!ev.target.checked);
        });
    }
    /**
     * It returns new input for the enabling inputs dimension.
     *
     * @param dimension
     */
    getInputUnitsEnabled(dimension) {
        return this.getCheckboxInput(dimension, (ev) => {
            var _a, _b;
            (_a = this.inputs) === null || _a === void 0 ? void 0 : _a.units.setDisabled(!ev.target.checked);
            (_b = this.inputs) === null || _b === void 0 ? void 0 : _b.unitsDesc.setDisabled(!ev.target.checked);
        });
    }
    /**
     * It returns new input for the units dimension.
     *
     * @param dimension
     */
    getInputUnits(dimension) {
        return this.getTextInput(dimension);
    }
    /**
     * It returns new input for the units description dimension.
     *
     * @param dimension
     */
    getInputUnitsDesc(dimension) {
        return this.getTextInput(dimension);
    }
    /**
     * It returns new input for the color dimension.
     *
     * @param dimension
     */
    getInputColor(dimension) {
        return this.getColorInput(dimension);
    }
    /**
     * It returns new input for the range dimension.
     *
     * @param dimension
     */
    getInputRange(dimension) {
        return this.getSliderInput(dimension);
    }
    /**
     * It returns new input for the scaling dimension.
     *
     * @param dimension
     */
    getInputScaling(dimension) {
        return this.getAutocompleteInput(dimension);
    }
    /**
     * It returns new input for the custom min-max dimension.
     *
     * @param dimension
     */
    getInputCustomMinMax(dimension) {
        return this.getCheckboxInput(dimension, (ev) => {
            var _a, _b, _c;
            (_a = this.inputs) === null || _a === void 0 ? void 0 : _a.scaling.setDisabled(ev.target.checked);
            (_b = this.inputs) === null || _b === void 0 ? void 0 : _b.minValue.setDisabled(!ev.target.checked);
            (_c = this.inputs) === null || _c === void 0 ? void 0 : _c.maxValue.setDisabled(!ev.target.checked);
        });
    }
    /**
     * It returns new input for the min value dimension.
     *
     * @param dimension
     */
    getInputMinValue(dimension) {
        return this.getNumberInput(dimension);
    }
    /**
     * It returns new input for the max value dimension.
     *
     * @param dimension
     */
    getInputMaxValue(dimension) {
        return this.getNumberInput(dimension);
    }
}

// Geovisto core
/**
 * This class provides the decimal scale.
 *
 * @author Jiri Hynek
 */
class DecimalScale extends MapDomain {
    /**
     * It initializes the scale.
     */
    constructor() {
        super(DecimalScale.TYPE());
    }
    /**
     * Type of the scale.
     */
    static TYPE() {
        return "decimal [0,max]";
    }
    /**
     * It returns a scale which can be used for choropleth color levels.
     *
     * @param values
     * @param size
     */
    getScale(values, size) {
        // find max value
        const max = values.reduce(function (prev, current) {
            return (prev > current) ? prev : current;
        });
        // get decimal logarithm
        const log = Math.round(Math.log10(max));
        // calculate scale step
        const step = Math.pow(10, Math.round(size / log));
        // construct scale
        const scale = [0];
        for (let i = 1, acc = 1; i < size; i++) {
            scale.push(acc);
            acc *= step;
        }
        return scale;
    }
}

// Geovisto core
/**
 * This class provides the median scale.
 *
 * @author Jiri Hynek
 */
class MedianScale extends MapDomain {
    /**
     * It initializes the scale.
     */
    constructor() {
        super(MedianScale.TYPE());
    }
    /**
     * Type of the scale.
     */
    static TYPE() {
        return "median";
    }
    /**
     * It returns a scale which can be used for choropleth color levels.
     *
     * @param values
     * @param size
     */
    getScale(values, size) {
        values.sort(function (a, b) { return a - b; });
        const scale = values.length > 0 ? [values[0] - 1] : [];
        for (let i = 1; i < size; i++) {
            scale.push(values[Math.round(values.length / size * (i))]);
        }
        return scale;
    }
}

// Geovisto core
/**
 * This class provides the relative [min,max] scale.
 *
 * @author Jiri Hynek
 */
class RelativeMinMaxScale extends MapDomain {
    /**
     * It initializes the scale.
     */
    constructor() {
        super(RelativeMinMaxScale.TYPE());
    }
    /**
     * Type of the scale.
     */
    static TYPE() {
        return "relative [min-max]";
    }
    /**
     * It returns a scale which can be used for choropleth color levels.
     *
     * @param values
     * @param size
     */
    getScale(values, size) {
        const scale = [];
        values.sort(function (a, b) { return a - b; });
        const step = (values[values.length - 1] - values[0]) / size;
        scale.push(values[0] - 1);
        for (let i = 1; i < size; i++) {
            scale.push(step * i);
        }
        return scale;
    }
}

// Geovisto core
/**
 * This class provides the relative [0,max] scale.
 *
 * @author Jiri Hynek
 */
class RelativeScale extends MapDomain {
    /**
     * It initializes the scale.
     */
    constructor() {
        super(RelativeScale.TYPE());
    }
    /**
     * Type of the scale.
     */
    static TYPE() {
        return "relative [0-max]";
    }
    /**
     * It returns a scale which can be used for choropleth color levels.
     *
     * @param values
     * @param size
     */
    getScale(values, size) {
        const scale = [];
        values.sort(function (a, b) { return a - b; });
        const step = values[values.length - 1] / size;
        scale.push(0);
        for (let i = 1; i < size; i++) {
            scale.push(step * i);
        }
        return scale;
    }
}

// Geovisto core
/**
 * This class provide functions which return the default state values.
 *
 * @author Jiri Hynek
 */
class ChoroplethLayerToolDefaults extends LayerToolDefaults {
    /**
     * It returns a unique type string of the tool which is based on the layer it wraps.
     */
    getType() {
        return ChoroplethLayerToolDefaults.TYPE;
    }
    /**
     * It returns the layer name.
     */
    getLayerName() {
        return "Choropleth layer";
    }
    /**
     * It returns the label of the tool.
     */
    getLabel() {
        return this.getLayerName();
    }
    /**
     * It returns the icon of the tool.
     */
    getIcon() {
        return '<i class="fa fa-th-large"></i>';
    }
    /**
     * It returns the map of layer dimensions.
     */
    getDimensions(map) {
        return {
            geoData: this.getGeoDataDimension(map),
            geoId: this.getGeoIdDimension(map),
            value: this.getValueDimension(map),
            aggregation: this.getAggregationDimension(),
            customColor: this.getCustomColorDimension(),
            color: this.getColorDimension(),
            range: this.getRangeDimension(),
            scaling: this.getScalingDimension(),
            customMinMax: this.getCustomMinMaxDimension(),
            minValue: this.getMinValueDimension(),
            maxValue: this.getMaxValueDimension(),
            units: this.getUnitsDimension(),
            unitsDesc: this.getUnitsDescDimension(),
            unitsEnabled: this.getUnitsEnabledDimension(),
            round: this.getRoundDimension(),
        };
    }
    /**
     * It returns the default geo ID dimension.
     */
    getGeoDataDimension(map) {
        return new MapDynamicDomainDimension("geo data", () => { var _a; return (_a = map === null || map === void 0 ? void 0 : map.getState().getGeoDataManager()) !== null && _a !== void 0 ? _a : this.getGeoDataManager(this.getGeoData()); }, "");
    }
    /**
     * It returns the default geo ID dimension.
     */
    getGeoIdDimension(map) {
        return new MapDynamicDomainDimension("geo id", () => { var _a; return (_a = map === null || map === void 0 ? void 0 : map.getState().getMapData()) !== null && _a !== void 0 ? _a : this.getDataManager(); }, "");
    }
    /**
     * It returns the default value dimension.
     */
    getValueDimension(map) {
        return new MapDynamicDomainDimension("value", () => { var _a; return (_a = map === null || map === void 0 ? void 0 : map.getState().getMapData()) !== null && _a !== void 0 ? _a : this.getDataManager(); }, "");
    }
    /**
     * It returns the default aggregation function dimension.
     */
    getAggregationDimension() {
        const domainManager = new MapDomainArrayManager([
            new CountAggregationFunction(),
            new SumAggregationFunction()
        ]);
        return new MapDomainDimension("aggregation", domainManager, domainManager.getDefault());
    }
    /**
     * It returns the animate direction dimension.
     */
    getCustomColorDimension() {
        return new MapTypeDimension("customColor", new BooleanTypeManager(), undefined);
    }
    /**
     * It returns the color dimension.
     */
    getColorDimension() {
        return new MapTypeDimension("color", new StringTypeManager(), "#E32400");
    }
    /**
     * It returns the range dimension.
     */
    getRangeDimension() {
        return new MapTypeDimension("range", new IntegerRangeManager(1, 7), 7);
    }
    /**
     * It returns the scaling dimension.
     */
    getScalingDimension() {
        const domainManager = new MapDomainArrayManager([
            new MedianScale(),
            new RelativeScale(),
            new RelativeMinMaxScale(),
            new DecimalScale(),
        ]);
        return new MapDomainDimension("scaling", domainManager, domainManager.getDefault());
    }
    /**
     * It returns the custom min-max dimension.
     */
    getCustomMinMaxDimension() {
        return new MapTypeDimension("customMinMax", new BooleanTypeManager(), undefined);
    }
    /**
     * It returns the min value dimension.
     */
    getMinValueDimension() {
        return new MapTypeDimension("minValue", new IntegerTypeManager(), undefined);
    }
    /**
     * It returns the max value dimension.
     */
    getMaxValueDimension() {
        return new MapTypeDimension("maxValue", new IntegerTypeManager(), undefined);
    }
    /**
     * It returns the units dimension.
     */
    getUnitsDimension() {
        return new MapTypeDimension("units", new StringTypeManager(), "");
    }
    /**
     * It returns the units description value dimension.
     */
    getUnitsDescDimension() {
        return new MapTypeDimension("unitsDesc", new StringTypeManager(), "");
    }
    /**
     * It returns the units state value dimension.
     */
    getUnitsEnabledDimension() {
        return new MapTypeDimension("unitsEnabled", new BooleanTypeManager(), false);
    }
    /**
     * It returns the round dimension.
     */
    getRoundDimension() {
        return new MapTypeDimension("round", new IntegerTypeManager(), undefined);
    }
    /**
     * It returns the default geo data.
     */
    getGeoData() {
        return [
        // TODO: provide default geo data
        ];
    }
    /**
     * It returns preferred z index for the choropoleth layer.
     */
    getZIndex() {
        return 350;
    }
}
/**
 * Static tool type constant.
 */
ChoroplethLayerToolDefaults.TYPE = "geovisto-tool-layer-choropleth";

// Geovisto core
/**
 * This class provide functions for using the state of the layer tool.
 *
 * @author Jiri Hynek
 */
class ChoroplethLayerToolState extends LayerToolState {
    /**
     * It creates a tool state.
     */
    constructor(tool) {
        super(tool);
    }
    /**
     * It resets state with respect to initial props.
     *
     * @param defaults
     * @param props
     * @param initProps
     */
    initialize(defaults, props, initProps) {
        // the choropleth layer tool properties
        if (props.dimensions) {
            this.setDimensions({
                geoData: props.dimensions.geoData == undefined ? defaults.getGeoDataDimension(initProps.map) : props.dimensions.geoData,
                geoId: props.dimensions.geoId == undefined ? defaults.getGeoIdDimension(initProps.map) : props.dimensions.geoId,
                value: props.dimensions.value == undefined ? defaults.getValueDimension(initProps.map) : props.dimensions.value,
                aggregation: props.dimensions.aggregation == undefined ? defaults.getAggregationDimension() : props.dimensions.aggregation,
                customColor: props.dimensions.customColor == undefined ? defaults.getCustomColorDimension() : props.dimensions.customColor,
                color: props.dimensions.color == undefined ? defaults.getColorDimension() : props.dimensions.color,
                range: props.dimensions.range == undefined ? defaults.getRangeDimension() : props.dimensions.range,
                scaling: props.dimensions.scaling == undefined ? defaults.getScalingDimension() : props.dimensions.scaling,
                customMinMax: props.dimensions.customMinMax == undefined ? defaults.getCustomMinMaxDimension() : props.dimensions.customMinMax,
                minValue: props.dimensions.minValue == undefined ? defaults.getMinValueDimension() : props.dimensions.minValue,
                maxValue: props.dimensions.maxValue == undefined ? defaults.getMaxValueDimension() : props.dimensions.maxValue,
                units: props.dimensions.units == undefined ? defaults.getUnitsDimension() : props.dimensions.units,
                unitsDesc: props.dimensions.unitsDesc == undefined ? defaults.getUnitsDimension() : props.dimensions.unitsDesc,
                unitsEnabled: props.dimensions.unitsEnabled == undefined ? defaults.getUnitsEnabledDimension() : props.dimensions.unitsEnabled,
                round: props.dimensions.round == undefined ? defaults.getRoundDimension() : props.dimensions.round,
            });
        }
        else {
            this.setDimensions(defaults.getDimensions(initProps.map));
        }
        this.setHoveredItem(undefined);
        this.setZIndex(defaults.getZIndex());
        this.setBucketData(new Map());
        // set super props
        super.initialize(defaults, props, initProps);
    }
    /**
     * The metod takes config and deserializes the values.
     *
     * @param config
     */
    deserialize(config) {
        super.deserialize(config);
    }
    /**
     * It sets the map layer dimensions property of tool state.
     *
     * @param dimensionsConfig
     */
    deserializeDimensions(dimensionsConfig) {
        const dimensions = this.getDimensions();
        if (dimensionsConfig.geoData)
            dimensions.geoData.setValue(dimensions.geoData.getDomainManager().getDomain(dimensionsConfig.geoData));
        if (dimensionsConfig.geoId)
            dimensions.geoId.setValue(dimensions.geoId.getDomainManager().getDomain(dimensionsConfig.geoId));
        if (dimensionsConfig.value)
            dimensions.value.setValue(dimensions.value.getDomainManager().getDomain(dimensionsConfig.value));
        if (dimensionsConfig.aggregation)
            dimensions.aggregation.setValue(dimensions.aggregation.getDomainManager().getDomain(dimensionsConfig.aggregation));
        if (dimensionsConfig.customColor !== undefined)
            dimensions.customColor.setValue(dimensionsConfig.customColor);
        if (dimensionsConfig.color)
            dimensions.color.setValue(dimensionsConfig.color);
        if (dimensionsConfig.range !== undefined)
            dimensions.range.setValue(dimensionsConfig.range);
        if (dimensionsConfig.scaling)
            dimensions.scaling.setValue(dimensions.scaling.getDomainManager().getDomain(dimensionsConfig.scaling));
        if (dimensionsConfig.customMinMax !== undefined)
            dimensions.customMinMax.setValue(dimensionsConfig.customMinMax);
        if (dimensionsConfig.minValue !== undefined)
            dimensions.minValue.setValue(dimensionsConfig.minValue);
        if (dimensionsConfig.maxValue !== undefined)
            dimensions.maxValue.setValue(dimensionsConfig.maxValue);
        if (dimensionsConfig.units !== undefined)
            dimensions.units.setValue(dimensionsConfig.units);
        if (dimensionsConfig.unitsDesc !== undefined)
            dimensions.unitsDesc.setValue(dimensionsConfig.unitsDesc);
        if (dimensionsConfig.unitsEnabled !== undefined)
            dimensions.unitsEnabled.setValue(dimensionsConfig.unitsEnabled);
        if (dimensionsConfig.round !== undefined)
            dimensions.round.setValue(dimensionsConfig.round);
    }
    /**
     * The method serializes the tool state. Optionally, defaults can be set if property is undefined.
     *
     * @param defaults
     */
    serialize(defaults) {
        var _a, _b, _c, _d, _e;
        const config = super.serialize(defaults);
        // serialize the layer tool properties
        const dimensions = this.getDimensions();
        config.data = {
            geoData: (_a = dimensions.geoData.getValue()) === null || _a === void 0 ? void 0 : _a.getName(),
            geoId: (_b = dimensions.geoId.getValue()) === null || _b === void 0 ? void 0 : _b.getName(),
            value: (_c = dimensions.value.getValue()) === null || _c === void 0 ? void 0 : _c.getName(),
            aggregation: (_d = dimensions.aggregation.getValue()) === null || _d === void 0 ? void 0 : _d.getName(),
            customColor: dimensions.customColor.getValue(),
            color: dimensions.color.getValue(),
            range: dimensions.range.getValue(),
            scaling: (_e = dimensions.scaling.getValue()) === null || _e === void 0 ? void 0 : _e.getName(),
            customMinMax: dimensions.customMinMax.getValue(),
            minValue: dimensions.minValue.getValue(),
            maxValue: dimensions.maxValue.getValue(),
            units: dimensions.units.getValue(),
            unitsDesc: dimensions.unitsDesc.getValue(),
            unitsEnabled: dimensions.unitsEnabled.getValue(),
            round: dimensions.round.getValue()
        };
        return config;
    }
    /**
     * It returns the map layer dimensions property of the tool state.
     */
    getDimensions() {
        return super.getDimensions();
    }
    /**
     * It sets the map layer dimensions property of tool state.
     *
     * @param dimensions
     */
    setDimensions(dimensions) {
        super.setDimensions(dimensions);
    }
    /**
     * It returns a Leaflet geoJSON layer.
     */
    getGeoJSONLayer() {
        return this.geoJSONlayer;
    }
    /**
     * It sets a Leaflet geoJSON layer.
     *
     * @param layer
     */
    setGeoJSONLayer(geoJSONlayer) {
        this.geoJSONlayer = geoJSONlayer;
    }
    /**
     * It returns the hovered item.
     */
    getHoveredItem() {
        return this.hoveredItem;
    }
    /**
     * It sets the hovered item.
     *
     * @param hoveredItem
     */
    setHoveredItem(hoveredItem) {
        this.hoveredItem = hoveredItem;
    }
    /**
     * It returns the z index.
     */
    getZIndex() {
        return this.zindex;
    }
    /**
     * It sets the z index.
     *
     * @param zindex
     */
    setZIndex(zindex) {
        this.zindex = zindex;
    }
    /**
     * It returns the bucket data.
     *
     * @param bucketData
     */
    getBucketData() {
        return this.bucketData;
    }
    /**
     * It sets the bucket data.
     *
     * @param bucketData
     */
    setBucketData(bucketData) {
        this.bucketData = bucketData;
    }
}

// Geovisto core
/**
 * This class provides the relative [min,max] scale.
 *
 * @author Jiri Hynek
 */
class CustomMinMaxScale extends MapDomain {
    /**
     * It initializes the scale.
     */
    constructor(min, max) {
        super(CustomMinMaxScale.TYPE());
        this.min = min;
        this.max = max;
    }
    /**
     * Type of the scale.
     */
    static TYPE() {
        return "custom [min-max]";
    }
    /**
     * It returns a scale which can be used for choropleth color levels.
     *
     * @param values
     * @param size
     */
    getScale(values, size) {
        const scale = [];
        const step = (this.max - this.min) / size;
        scale.push(this.min - 1);
        for (let i = 1; i < size; i++) {
            scale.push(step * i);
        }
        return scale;
    }
}

// Geovisto core
/**
 * This class provides controls for management of the layer legend.
 *
 * @author Tomas Koscielniak
 */
class ChoroplethLayerToolMapLegend extends MapLayerToolLegend {
    /**
     * It creates new map Legend with respect to the given props.
     *
     * @param tool
     */
    constructor(tool) {
        super(tool);
    }
    /**
     * It returns the legend.
     */
    getContent(tool) {
        const div = document.createElement('div');
        div.className = "legend";
        // Get scale
        const scale = tool.getScale();
        if (!(scale) || scale[0] == undefined) {
            // If legend is already created
            if (this.htmlContent != undefined) {
                div.id = "geovisto-tool-layer-choropleth-legend";
                div.innerHTML += '<span style="font-weight: bold;">Unknown values</span><br>';
                this.htmlContent = div;
                return this.htmlContent;
            }
            // No available scales - dont create legend
            return undefined;
        }
        // Get colors
        const color_opacities = [];
        const color = tool === null || tool === void 0 ? void 0 : tool.getState().getDimensions().color.getValue();
        // Separate thousands for numerical ranges
        const separateThousands = (num) => {
            const numParts = num.toString().split(".");
            numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return numParts.join(".");
        };
        // Conver values to string
        let categories = scale;
        // Get rid of duplicit values if there are any
        const unique_vals = [];
        for (let i = 0; i < categories.length; i++) {
            let occurence_counter = 0;
            for (let j = 0; j < categories.length; j++) {
                if (categories[j] == categories[i]) {
                    occurence_counter++;
                }
            }
            if (occurence_counter == 1) {
                unique_vals.push(categories[i]);
            }
        }
        categories = unique_vals;
        // Compute color intensity
        for (let i = 0; i < categories.length; i++) {
            color_opacities.push(tool === null || tool === void 0 ? void 0 : tool.computeColorIntensity(categories[i], categories));
        }
        // Shift the array
        color_opacities.push(color_opacities.shift());
        const opacities = color_opacities.map(String);
        // Check if rounding is set
        if (tool.getState().getDimensions().round.getValue() != undefined) {
            for (let i = 0; i < categories.length; i++) {
                categories[i] = roundValues(categories[i], tool.getState().getDimensions().round.getValue());
            }
        }
        const values = [];
        for (let i = 0; i < categories.length; i++) {
            if (categories[i]) {
                values.push(separateThousands(categories[i]));
            }
        }
        div.id = "geovisto-tool-layer-choropleth-legend";
        let units = tool.getState().getDimensions().units.getValue();
        if (tool.getState().getDimensions().unitsEnabled.getValue() == false) {
            units = "";
        }
        // Create categories
        for (let i = 0; i < values.length; i++) {
            if (values.length == i + 1) {
                div.innerHTML += '<i style="opacity: ' + opacities[i] +
                    '; background: ' + color + '"></i><span>' + values[i] + ' + ' +
                    units + '</span><br>';
            }
            else {
                div.innerHTML += '<i style="opacity: ' + opacities[i] +
                    '; background: ' + color + '"></i><span>(' + values[i] + ' - ' + values[i + 1] + '] ' +
                    units + '</span><br>';
            }
        }
        // Check if longer units are available and allowed
        if (tool.getState().getDimensions().unitsDesc.getValue() != "" && tool.getState().getDimensions().unitsEnabled.getValue() == true) {
            div.innerHTML += "<span>Units: " + tool.getState().getDimensions().unitsDesc.getValue() + "</span>";
        }
        this.htmlContent = div;
        return this.htmlContent;
    }
}

// Leaflet
/**
 * This class represents Choropleth layer tool. It works with geojson polygons representing countries.
 *
 * @author Jiri Hynek
 */
class ChoroplethLayerTool extends AbstractLayerTool {
    /**
     * It creates a new tool with respect to the props.
     *
     * @param props
     */
    constructor(props) {
        super(props);
    }
    /**
     * It creates a copy of the uninitialized tool.
     */
    copy() {
        return new ChoroplethLayerTool(this.getProps());
    }
    /**
     * It returns the props given by the programmer.
     */
    getProps() {
        return super.getProps();
    }
    /**
     * It returns default values of the state properties.
     */
    getDefaults() {
        return super.getDefaults();
    }
    /**
     * It creates new defaults of the tool.
     */
    createDefaults() {
        return new ChoroplethLayerToolDefaults();
    }
    /**
     * It returns the layer tool state.
     */
    getState() {
        return super.getState();
    }
    /**
     * It returns default tool state.
     */
    createState() {
        return new ChoroplethLayerToolState(this);
    }
    /**
     * Help function which acquires and returns the selection tool if available.
     */
    getSelectionTool() {
        var _a;
        if (this.selectionToolAPI == undefined) {
            const api = (_a = this.getMap()) === null || _a === void 0 ? void 0 : _a.getState().getToolsAPI();
            if (api.getGeovistoSelectionTool) {
                this.selectionToolAPI = api.getGeovistoSelectionTool();
            }
        }
        return this.selectionToolAPI;
    }
    /**
     * Help function which acquires and returns the themes tool if available.
     */
    getThemesTool() {
        var _a;
        if (this.themesToolAPI == undefined) {
            const api = (_a = this.getMap()) === null || _a === void 0 ? void 0 : _a.getState().getToolsAPI();
            if (api.getGeovistoThemesTool) {
                this.themesToolAPI = api.getGeovistoThemesTool();
            }
        }
        return this.themesToolAPI;
    }
    /**
     * It returns a sidebar tab with respect to the configuration.
     */
    getMapForm() {
        if (this.mapForm == undefined) {
            this.mapForm = this.createMapForm();
        }
        return this.mapForm;
    }
    /**
     * It creates new tab control.
     */
    createMapForm() {
        // override if needed
        return new ChoropolethLayerToolMapForm(this);
    }
    /**
     * It creates new legend control.
     */
    createMapLegend() {
        return new ChoroplethLayerToolMapLegend(this);
    }
    /**
     * It returns a legend.
     */
    getMapLegend() {
        if (this.mapLegend == undefined) {
            this.mapLegend = this.createMapLegend();
        }
        return this.mapLegend;
    }
    /**
     * Overrides the super method.
     *
     * @param initProps
     */
    initialize(initProps) {
        return super.initialize(initProps);
    }
    /**
     * It creates layer items.
     */
    createLayerItems() {
        var _a, _b, _c, _d, _e;
        const map = (_a = this.getMap()) === null || _a === void 0 ? void 0 : _a.getState().getLeafletMap();
        if (map) {
            const paneId = this.getId();
            const pane = (_c = (_b = this.getMap()) === null || _b === void 0 ? void 0 : _b.getState().getLeafletMap()) === null || _c === void 0 ? void 0 : _c.createPane(paneId);
            if (pane) {
                // set z-index
                pane.style.zIndex = this.getState().getZIndex().toString();
                // create geojson layer
                const geoJSONlayer = this.createGeoJSONLayer();
                this.getState().setGeoJSONLayer(geoJSONlayer);
                // Check if hierarchy items are enabled, else it makes all polygons availibale at start.
                const domManager = this.getState().getDimensions().geoData.getDomainManager();
                const domainName = (_e = (_d = this.getState().getDimensions().geoData.getValue()) === null || _d === void 0 ? void 0 : _d.getName()) !== null && _e !== void 0 ? _e : "";
                const geo = domManager.getFeatures(domainName, [GeoJSONTypes.MultiPolygon, GeoJSONTypes.Polygon]);
                const hierarchyFlag = (domManager.isHierarchyEnabled() && domManager.isHierarchyEnabledForDomain(domainName)) ? true : false;
                if (geo && hierarchyFlag) {
                    this.updateGeoData();
                }
                return [geoJSONlayer];
            }
        }
        return [];
    }
    /**
     * It creates an instance of the Leaflet GeoJSON layer.
     */
    createGeoJSONLayer() {
        var _a;
        const geoJSON = (_a = this.getState().getDimensions().geoData.getValue()) === null || _a === void 0 ? void 0 : _a.getFeatures([GeoJSONTypes.MultiPolygon, GeoJSONTypes.Polygon]);
        const layer = new L.GeoJSON(geoJSON, {
            onEachFeature: this.getOnEachFeatureFunction(),
            pane: this.getId()
        });
        return layer;
    }
    /**
     * It returns the onEachFeature property for the GeoJSON layer.
     */
    getOnEachFeatureFunction() {
        return (feature, layer) => {
            layer.on({
                mouseover: this.getMouseOverFunction(),
                mouseout: this.getMouseOutFunction(),
                click: this.getClickFunction()
            });
        };
    }
    /**
     * It returns the mouseover property for the GeoJSON layer.
     */
    getMouseOverFunction() {
        const separateThousands = (num) => {
            const numParts = num.toString().split(".");
            numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return numParts.join(".");
        };
        return (e) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            const layerItem = e.target;
            const id = (_b = (_a = layerItem.feature) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString();
            this.getState().setHoveredItem(id);
            this.hoverItem(layerItem, true);
            this.getState().getBucketData().get((_e = (_d = (_c = layerItem.feature) === null || _c === void 0 ? void 0 : _c.id) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : "");
            let popupText;
            let units = this.getState().getDimensions().units.getValue();
            // Check if units are not disabled
            if (this.getState().getDimensions().unitsEnabled.getValue() == false) {
                units = "";
            }
            if (this.getState().getDimensions().round.getValue() != undefined) {
                popupText = "<b>" + e.target.feature.name + "</b><br>"
                    + ((_f = this.getState().getDimensions().aggregation.getValue()) === null || _f === void 0 ? void 0 : _f.getName()) + ": "
                    + separateThousands(id ? (roundValues((_h = (_g = this.getState().getBucketData().get(id)) === null || _g === void 0 ? void 0 : _g.getValue()) !== null && _h !== void 0 ? _h : 0, this.getState().getDimensions().round.getValue())) : 0)
                    + (units == "" ? "" : (" " + units));
            }
            else {
                popupText = "<b>" + e.target.feature.name + "</b><br>"
                    + ((_j = this.getState().getDimensions().aggregation.getValue()) === null || _j === void 0 ? void 0 : _j.getName()) + ": "
                    + separateThousands(id ? ((_l = (_k = this.getState().getBucketData().get(id)) === null || _k === void 0 ? void 0 : _k.getValue()) !== null && _l !== void 0 ? _l : 0) : 0)
                    + (units == "" ? "" : (" " + units));
            }
            e.target.bindTooltip(popupText, { className: 'leaflet-popup-content', sticky: true }).openTooltip();
            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                layerItem.bringToFront();
            }
        };
    }
    /**
     * It returns the mouseout property for the GeoJSON layer.
     */
    getMouseOutFunction() {
        return (e) => {
            const layerItem = e.target;
            this.getState().setHoveredItem(undefined);
            this.hoverItem(layerItem, false);
            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                layerItem.bringToBack();
            }
        };
    }
    /**
     * It returns the click property for the GeoJSON layer.
     */
    getClickFunction() {
        return (e) => {
            var _a, _b;
            // notify selection tool
            const selectionToolAPI = this.getSelectionTool();
            if (selectionToolAPI) {
                const id = (_b = (_a = e.target.feature) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString();
                if (id) {
                    const selection = selectionToolAPI.createSelection(this, [id]);
                    if (selection.equals(selectionToolAPI.getSelection())) {
                        selectionToolAPI.setSelection(null);
                    }
                    else {
                        selectionToolAPI.setSelection(selection);
                    }
                }
            }
        };
    }
    /**
     * It updates the polygons of the layer so they represent current geo data.
     *
     * @returns
     */
    updateGeoData() {
        var _a, _b, _c;
        const layer = this.getState().getGeoJSONLayer();
        if (layer) {
            layer.clearLayers();
            // Hierarchy check for availability of selected domain. 
            const domManager = this.getState().getDimensions().geoData.getDomainManager();
            const domainName = (_b = (_a = this.getState().getDimensions().geoData.getValue()) === null || _a === void 0 ? void 0 : _a.getName()) !== null && _b !== void 0 ? _b : "";
            const geo = domManager.getFeatures(domainName, [GeoJSONTypes.MultiPolygon, GeoJSONTypes.Polygon]);
            const hierarchyFlag = (domManager.isHierarchyEnabled() && domManager.isHierarchyEnabledForDomain(domainName)) ? true : false;
            const geoJSON = (_c = this.getState().getDimensions().geoData.getValue()) === null || _c === void 0 ? void 0 : _c.getFeatures([GeoJSONTypes.MultiPolygon, GeoJSONTypes.Polygon]);
            // If there are active objects, and hierarchy is enabled globaly and for selected domain, create hierarchy layer.
            if (geo && hierarchyFlag) {
                layer.addData(geo);
                return layer;
            }
            else if (geoJSON) {
                layer.addData(geoJSON);
                return layer;
            }
            if (geoJSON) {
                layer.addData(geoJSON);
            }
        }
        return layer;
    }
    /**
     * It updates the bucket data so it represents the current data.
     */
    updateData() {
        var _a, _b;
        let hierarchySucces = false;
        let bucketHierarchyMap = new Map();
        // initialize a hash map of aggreation buckets
        const bucketMap = new Map();
        // get dimensions
        const dimensions = this.getState().getDimensions();
        const geoIdDimension = dimensions.geoId.getValue();
        const valueDimension = dimensions.value.getValue();
        const aggregationDimension = dimensions.aggregation.getValue();
        const map = this.getMap();
        // test whether the dimension are set
        if (geoIdDimension && aggregationDimension && map) {
            // and go through all data records
            const mapData = map.getState().getMapData();
            const data = map.getState().getCurrentData();
            const dataLen = data.length;
            let foundGeos, foundValues;
            let aggregationBucket;
            for (let i = 0; i < dataLen; i++) {
                // find the 'geo' properties of the data record
                foundGeos = mapData.getDataRecordValues(geoIdDimension, data[i]);
                // since the data are flattened we can expect max one found item
                if (foundGeos.length == 1 && typeof foundGeos[0] === "string") {
                    // get aggregation bucket for the country or create a new one
                    aggregationBucket = bucketMap.get(foundGeos[0]);
                    if (!aggregationBucket) {
                        aggregationBucket = aggregationDimension.getAggregationBucket();
                        bucketMap.set(foundGeos[0], aggregationBucket);
                    }
                    // find the 'value' properties
                    foundValues = valueDimension ? mapData.getDataRecordValues(valueDimension, data[i]) : [1];
                    // since the data are flattened we can expect max one found item
                    aggregationBucket.addValue(foundValues.length == 1 ? (typeof foundValues[0] === "number" ? foundValues[0] : 1) : 0);
                }
            }
            // hierarchy support
            const domManager = this.getState().getDimensions().geoData.getDomainManager();
            const domainName = (_b = (_a = this.getState().getDimensions().geoData.getValue()) === null || _a === void 0 ? void 0 : _a.getName()) !== null && _b !== void 0 ? _b : "";
            // if aggregation is enabled in hierarchy mode, aggregate.
            if (domManager.isHierarchyEnabledForDomain(domainName) && domManager.isHierarchyEnabled()) {
                const active = domManager.getActiveByTree(domainName);
                // If aggregation is enabled, start aggregating
                if (domManager.treeAggregationFlag(domainName)) {
                    // Iterate over active objects, creates aggregation bucket for each.
                    active.forEach(activeGeo => {
                        let aggrBucket;
                        // Get childs of active object.
                        const childs = domManager.getChildsFromTree(domainName, activeGeo);
                        if (!bucketHierarchyMap.has(activeGeo)) {
                            aggrBucket = aggregationDimension.getAggregationBucket();
                            bucketHierarchyMap.set(activeGeo, aggrBucket);
                        }
                        // Iterates over childs
                        childs.forEach(child => {
                            var _a;
                            if (bucketMap.has(child)) {
                                if (aggrBucket) {
                                    const ans = (_a = bucketMap.get(child)) === null || _a === void 0 ? void 0 : _a.getValue();
                                    // Check if aggregation type is count or sum.
                                    if (aggregationDimension.getName() === "count") {
                                        if (ans) {
                                            for (let cnt = 0; cnt < ans; cnt++) {
                                                aggrBucket.addValue(1);
                                            }
                                        }
                                    }
                                    else {
                                        aggrBucket.addValue(typeof ans === "number" ? ans : 1);
                                    }
                                }
                            }
                        });
                    });
                    // If agregation is disabled, just copy bucket Map form original aggregation.
                }
                else {
                    bucketHierarchyMap = bucketMap;
                }
                hierarchySucces = true;
            }
        }
        // Updates bucket data
        if (hierarchySucces) {
            this.getState().setBucketData(bucketHierarchyMap);
            return bucketHierarchyMap;
        }
        else {
            this.getState().setBucketData(bucketMap);
            return bucketMap;
        }
    }
    /**
     * It reloads data and redraw the layer.
     *
     * @param type
     */
    render(type, animateOptions) {
        switch (type) {
            case LayerToolRenderType.LAYER:
                this.updateGeoData();
                this.updateData();
                this.updateStyle();
                break;
            case LayerToolRenderType.DATA:
                this.updateData();
                this.updateStyle(animateOptions);
                break;
            default:
                // update style
                this.updateStyle(animateOptions);
                break;
        }
        super.render(type);
    }
    /**
     * It updates the dimension.
     *
     * @param dimension
     * @param value
     * @param redraw
     */
    updateDimension(dimension, value, redraw) {
        if (!redraw) {
            const dimensions = this.getState().getDimensions();
            switch (dimension) {
                case dimensions.geoData:
                    redraw = LayerToolRenderType.LAYER;
                    break;
                case dimensions.geoId:
                case dimensions.value:
                case dimensions.aggregation:
                    redraw = LayerToolRenderType.DATA;
                    break;
                default:
                    redraw = LayerToolRenderType.STYLE;
                    break;
            }
        }
        super.updateDimension(dimension, value, redraw);
    }
    /**
     * This function is called when a custom event is invoked.
     *
     * @param event
     */
    handleEvent(event) {
        var _a, _b;
        switch (event.getType()) {
            case GeoDataManagerChangeEvent.TYPE():
                this.render(LayerToolRenderType.LAYER);
                break;
            case GeoDataChangeEvent.TYPE():
                this.render(LayerToolRenderType.LAYER);
                break;
            case DataManagerChangeEvent.TYPE():
                this.render(LayerToolRenderType.DATA);
                break;
            case DataChangeEvent.TYPE():
                this.render(LayerToolRenderType.DATA, event.getAnimateOptions());
                break;
            case (_a = this.getSelectionTool()) === null || _a === void 0 ? void 0 : _a.getChangeEventType():
                this.render(LayerToolRenderType.STYLE);
                break;
            case (_b = this.getThemesTool()) === null || _b === void 0 ? void 0 : _b.getChangeEventType():
                this.updateTheme(event.getChangedObject());
                this.render(LayerToolRenderType.STYLE);
                break;
        }
    }
    /**
     * Help function which updates theme with respect to the Themes Tool API.
     *
     * TODO: move to adapter
     *
     * @param theme
     */
    updateTheme(theme) {
        document.documentElement.style.setProperty('--choropleth-item-hover', theme.getHoverColor());
        document.documentElement.style.setProperty('--choropleth-item-select', theme.getHighlightColor().selected);
        document.documentElement.style.setProperty('--choropleth-item-highlight', theme.getHighlightColor().highlight);
    }
    /**
     * It updates style of all layer features using the current template.
     */
    updateStyle(animateOptions) {
        var _a;
        const scale = this.getScale();
        if (scale && scale.length > 0) {
            (_a = this.getState().getGeoJSONLayer()) === null || _a === void 0 ? void 0 : _a.eachLayer((item) => {
                this.updateItemStyle(item, scale, animateOptions);
            });
        }
    }
    /**
     * Help function which returns a scale which can be used to distinguish value levels in choropleth.
     */
    getScale() {
        var _a;
        // get values
        const values = [];
        let id;
        let value;
        (_a = this.getState().getGeoJSONLayer()) === null || _a === void 0 ? void 0 : _a.eachLayer((item) => {
            var _a, _b, _c, _d;
            id = (_c = (_b = (_a = item.feature) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : "";
            if (id !== undefined) {
                value = (_d = this.getState().getBucketData().get(id)) === null || _d === void 0 ? void 0 : _d.getValue();
                if (value) {
                    values.push(value);
                }
            }
        });
        // calculate scale based on user inputs
        let scale = undefined;
        const dimensions = this.getState().getDimensions();
        const rangeDimension = dimensions.range.getValue();
        if (rangeDimension) {
            const customMinMaxDimension = dimensions.customMinMax.getValue();
            const scalingDimension = dimensions.scaling.getValue();
            if (customMinMaxDimension) {
                const minDimension = dimensions.minValue.getValue();
                const maxDimension = dimensions.maxValue.getValue();
                if (minDimension !== undefined && maxDimension !== undefined) {
                    scale = (new CustomMinMaxScale(minDimension, maxDimension)).getScale(values, rangeDimension);
                }
                else {
                    scale = (new RelativeScale()).getScale(values, rangeDimension);
                }
            }
            else if (scalingDimension) {
                scale = scalingDimension.getScale(values, rangeDimension);
            }
        }
        return scale;
    }
    /**
     * It updates style of the given feature using the current template.
     */
    updateItemStyle(item, scale, animateOptions) {
        // TODO: use setStyle instead
        //item.setStyle(this.computeStyle(item));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const anyItem = item;
        if (anyItem._path != undefined) {
            // animation styles
            if (animateOptions) {
                anyItem._path.style.transitionDuration = `${animateOptions.transitionDuration}ms`;
                anyItem._path.style.transitionDelay = `${animateOptions.transitionDelay}ms`;
            }
            // class list
            anyItem._path.classList.value = this.computeStyleClasses(item, scale).join(" ");
        }
    }
    /**
     * It returns style classes for the current template and given feature.
     */
    computeStyleClasses(item, scale) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const classList = ["leaflet-interactive", "leaflet-choropleth-item-basic"];
        const feature = item.feature;
        const id = (_b = (_a = feature === null || feature === void 0 ? void 0 : feature.id) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "";
        // get value
        const value = (_d = (_c = this.getState().getBucketData().get(id)) === null || _c === void 0 ? void 0 : _c.getValue()) !== null && _d !== void 0 ? _d : 0;
        // use color according to the user's preferences
        const dimensions = this.getState().getDimensions();
        const customColor = dimensions.customColor.getValue();
        const color = dimensions.color.getValue();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const path = item._path;
        if (customColor && color) {
            if (value && value >= scale[0]) {
                // compute color level of custom color
                path.style.fill = color;
                path.style.fillOpacity = this.computeColorIntensity(value, scale);
            }
            else {
                // very low value is represented rather by a light gray (not the fully transparent color)
                path.style.fill = "grey";
                path.style.fillOpacity = 0.3;
            }
        }
        else {
            // compute color level of the palette of predefined colors
            classList.push(this.computeColorClass((_f = (_e = this.getState().getBucketData().get(id)) === null || _e === void 0 ? void 0 : _e.getValue()) !== null && _f !== void 0 ? _f : 0, scale));
            // explicit opacity is not required here
            path.style.fill = null;
            path.style.fillOpacity = null;
        }
        // add info about part of map to path attribute (for testing purposes)
        path._current = { shortId: feature === null || feature === void 0 ? void 0 : feature.id };
        // selected / highlighted
        const selection = (_h = (_g = this.getSelectionTool()) === null || _g === void 0 ? void 0 : _g.getSelection()) !== null && _h !== void 0 ? _h : undefined;
        const selectedIds = (_j = selection === null || selection === void 0 ? void 0 : selection.getIds()) !== null && _j !== void 0 ? _j : [];
        if (selection && selectedIds.length > 0) {
            path.style.fill = null;
            path.style.fillOpacity = null;
            if (selectedIds.includes(id)) {
                if (selection.getTool() == this && selection.getSrcIds().includes(id)) {
                    // selected
                    classList.push("leaflet-choropleth-item-select");
                }
                else {
                    // affected, highlighted
                    classList.push("leaflet-choropleth-item-highlight");
                }
            }
            else {
                // de-emphasize others
                classList.push("leaflet-choropleth-item-deempasize");
            }
        }
        // hover
        if (this.getState().getHoveredItem() == id) {
            classList.push("leaflet-choropleth-item-hover");
        }
        return classList;
    }
    /**
     * It returns color class for the current scale and given value.
     *
     * @param val
     * @param scale
     */
    computeColorClass(val, scale) {
        for (let i = scale.length - 1; i >= 0; i--) {
            if (val > scale[i]) {
                return "leaflet-choropleth-item-clr" + (i + 1);
            }
        }
        return "leaflet-choropleth-item-clr0";
    }
    /**
     * It returns color intensity for the current scale and given value.
     *
     * @param val
     * @param scale
     */
    computeColorIntensity(val, scale) {
        for (let i = scale.length - 1; i >= 0; i--) {
            if (val > scale[i]) {
                // round to 2 decimals
                return Math.round(((i + 1) / (scale.length)) * 100) / 100;
            }
        }
        return 0.9;
    }
    /**
     * It updates style of the given feature using the current template.
     */
    hoverItem(item, hover) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (item._path != undefined) {
            // modify classes
            if (hover) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                item._path.classList.add("leaflet-choropleth-item-hover");
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                item._path.classList.remove("leaflet-choropleth-item-hover");
            }
        }
    }
}

const GeovistoChoroplethLayerTool = {
    getType: () => ChoroplethLayerToolDefaults.TYPE,
    createTool: (props) => new ChoroplethLayerTool(props),
};

export { ChoroplethLayerTool, ChoroplethLayerToolDefaults, ChoropolethLayerToolMapForm as ChoroplethLayerToolMapForm, ChoroplethLayerToolMapLegend, ChoroplethLayerToolState, CustomMinMaxScale, DecimalScale, GeovistoChoroplethLayerTool, MedianScale, RelativeMinMaxScale, RelativeScale };
//# sourceMappingURL=index.es.js.map
